import { Adsense } from '@ctrl/react-adsense';

export const AdSenseBanner = ({ slot }: { slot: string }) => <Adsense client='ca-pub-4321911283255728' slot={slot} />;

export default AdSenseBanner;
